// extracted by mini-css-extract-plugin
export default {"results-list-container":"ResultsList_results-list-container__63FIH","results-table":"ResultsList_results-table__LI94h"};